import {mafia} from "./automations/mafia";
import {common} from "./common/common";
import {colors} from "./common/colors/colors";
import {modals} from "./modals/modals";
import {tableHand} from "./table-hand/table-hand";
import {button} from "./button/button";

export const messages = {
    en: {
        common: {
            min: 'min',
            sec: 'sec',
            guest: 'Guest',
            age: 'Age'
        },
        color: colors.en,
        catalog_filters: {
            types: 'Type',
            gameplay: 'Gameplay',
            age: 'Age',
            time: 'Time',
            players_number: 'Number of players',
            reset_filters: 'Reset filters'
        },
        message: common.en.message,
        button: button.en,
        date: {
            d: 'd',
            h: 'h',
            min: 'min',
        },
        radial_menu: tableHand.en.radial_menu,
        modals: modals.en,
        hand: tableHand.en.hand,
        forms: {
            errors: {
                nothing_to_upload: 'You have nothing to upload'
            }
        },
        smallWindow: {
            title: 'You opened Festa from a too small screen or device',
            text: 'Please log in from another device or open a window larger than 1200 px'
        },
        mafia: mafia.en
    },
    ru: {
        common: {
            min: 'мин',
            sec: 'сек',
            guest: 'Гость',
        },
        color: colors.ru,
        catalog_filters: {
            types: 'Тип',
            gameplay: 'Геймплей',
            age: 'Возраст',
            time: 'Время',
            players_number: 'Количество игроков',
            reset_filters: 'Сбросить фильтры'
        },
        message: common.ru.message,
        button: button.ru,
        date: {
            d: 'д',
            h: 'ч',
            min: 'м',
        },
        radial_menu: tableHand.ru.radial_menu,
        modals: modals.ru,
        hand: tableHand.ru.hand,
        forms: {
            errors: {
                nothing_to_upload: 'Нечего загружать'
            }
        },
        smallWindow: {
            title: 'You opened Festa from a too small screen or device',
            text: 'Please log in from another device or open a window larger than 1200 px'
        },
        mafia: mafia.ru
    }
};
